import React from 'react';
import { CircularProgress, TextField, Grid } from '@mui/material';
import useGetInvestorsLeanResponse from 'hooks/data/investor/useGetInvestorsLeanResponse';
import AppAutocomplete from 'components/FormElements/AppAutocomplete';

type InvestorSearchProps = {
  onInvestorSelect: (investorId?: string) => void;
  selectedInvestorId?: string;
  firmId?: string;
  error?: boolean;
  helperText?: string | React.ReactNode;
  excludeInvestorOptionById?: Array<string>;
  disabled?: boolean;
};

const InvestorSearch: React.FC<InvestorSearchProps> = ({
  onInvestorSelect,
  selectedInvestorId,
  firmId,
  error,
  helperText,
  excludeInvestorOptionById,
  disabled,
  ...rest
}) => {
  const { data: investors, isFetching } = useGetInvestorsLeanResponse({
    firmId,
  });

  const filteredInvestors = investors?.filter(
    (investor) => !excludeInvestorOptionById?.includes(investor._id),
  );

  if (isFetching) {
    return (
      <Grid size={{ xs: 12 }}>
        <CircularProgress size={24} />
      </Grid>
    );
  }

  return (
    <AppAutocomplete
      {...rest}
      disabled={disabled}
      options={filteredInvestors ?? []}
      id="investorSearch"
      //@ts-expect-error
      getOptionLabel={(option: (typeof filteredInvestors)[number]) =>
        `${option.fullName} (${option.email})`
      }
      getOptionKey={(option) => option._id}
      filterSelectedOptions
      //@ts-expect-error
      onChange={(_: unknown, investor: (typeof filteredInvestors)[number]) => {
        if (!investor) return onInvestorSelect();
        onInvestorSelect(investor._id);
      }}
      value={filteredInvestors?.find(({ _id }) => _id === selectedInvestorId)}
      renderInput={(params: object) => (
        <TextField
          error={error}
          helperText={helperText}
          {...params}
          variant="outlined"
          placeholder="Search by name or email"
        />
      )}
    />
  );
};

export default InvestorSearch;
